import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import FetchViewBugtrackingData from './FetchViewBugtrackingData';
import FetchViewBugWAFData from './FetchViewBugWAFData';
import { SiteTitle } from "../SiteTitle";


function BUGBackground() {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <SiteTitle />
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="tracking tabs"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "blue",
                            }
                        }}
                    >
                        <Tab label="漏洞追蹤" value="1" />
                        <Tab label="WAF報告" value="2" />
                    </Tabs>
                </Box>
                <TabPanel value="1">
                    <FetchViewBugtrackingData />
                </TabPanel>
                <TabPanel value="2">
                    <FetchViewBugWAFData />
                </TabPanel>
            </TabContext>
        </div>
    );
}

export default BUGBackground;
